import React, { Component } from 'react'
import { X } from 'react-feather'

class Help extends Component{
  constructor() {
    super();
    this.state = {
      show: false
    }

    this.toggleWindow = this.toggleWindow.bind(this)
  }

  toggleWindow() {
    this.setState(prevState => ({show: !prevState.show}))
  }

  render() {
    return(
      <div>
        <div className="Help" onClick={this.toggleWindow}>
          {
            this.state.show
            ?
            <X />
            :
            <p>?</p>
          }
        </div>
        {
          this.state.show
          ?
          <div className="Help-window">
            <p>
              Behöver du hjälp eller är det något du undrar över? <br/><br/>
            Skicka ett mail till <a href="mailto:info@escapat.com">info@escapat.com</a> så hjälper vi dig gärna.<br/><br/>
              Du kan även ringa oss på <a href="tel:0707699761">070-769 97 61</a>
            </p>
          </div>
          :
          null
        }
      </div>
    )
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/components/Help.jsx